import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '@/shared/hooks/queries/queryKeys'
import { getLineStatus } from '@/features/internal/patient-messaging/apis/patientMessagingApi'

export const useLineStatusQuery = (patientId: string) => {
  return useQuery({
    queryKey: queryKeys.patientMessaging.lineStatus(patientId),
    queryFn: () => getLineStatus(patientId),
    enabled: !!patientId,
  })
}
